// extracted by mini-css-extract-plugin
export default {"arrow_down":"ArrowDown_arrow_down__7Ho4+","arrow_down_icon":"ArrowDown_arrow_down_icon__xWmXo"};